import { render, staticRenderFns } from "./sbSelect.vue?vue&type=template&id=0cbc1ef9&scoped=true"
import script from "./sbSelect.vue?vue&type=script&lang=js"
export * from "./sbSelect.vue?vue&type=script&lang=js"
import style0 from "./sbSelect.vue?vue&type=style&index=0&id=0cbc1ef9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc1ef9",
  null
  
)

export default component.exports